// extracted by mini-css-extract-plugin
export default {"cls1":"uvCoeHbVjdh1KbKVA7zz","cls2":"Hm7rU4pkrm1WI9GORDL0 uvCoeHbVjdh1KbKVA7zz"};